import { IOrganization } from '../organization/organization';
import { IPartner } from '../partner/partner';

export enum AccountState {
  Active = 'ACTIVE',
  Locked = 'LOCKED',
  Deactivated = 'DEACTIVATED',
}

export enum RoleName {
  READ_NON_SENSITIVE = 'READ_NON_SENSITIVE',
  READ_USERS = 'READ_USERS',
  WRITE_USERS = 'WRITE_USERS',
  READ_ORGS = 'READ_ORGS',
  WRITE_ORGS = 'WRITE_ORGS',
  READ_HUBS = 'READ_HUBS',
  WRITE_HUBS = 'WRITE_HUBS',
  READ_QUOTES = 'READ_QUOTES',
  WRITE_QUOTES = 'WRITE_QUOTES',
  READ_BOOKINGS = 'READ_BOOKINGS',
  WRITE_BOOKINGS = 'WRITE_BOOKINGS',
  READ_TRANSCOS = 'READ_TRANSCOS',
  WRITE_TRANSCOS = 'WRITE_TRANSCOS',
  READ_PARTNERS = 'READ_PARTNERS',
  WRITE_PARTNERS = 'WRITE_PARTNERS',
  READ_INVOICES = 'READ_INVOICES',
  WRITE_INVOICES = 'WRITE_INVOICES',
  SEND_EMAIL = 'SEND_EMAIL',
  VIEW_SENT_EMAIL = 'VIEW_SENT_EMAIL',
  TRIGGER_DATA_SYNC = 'TRIGGER_DATA_SYNC',
  MANAGE_DATA_SYNC = 'MANAGE_DATA_SYNC',
  GEO_SEARCH = 'GEO_SEARCH',
  CREATE_BOOKINGS = 'CREATE_OWN_BOOKINGS',
  VIEW_OWN_BOOKINGS = 'VIEW_OWN_BOOKINGS',
  ACCEPT_JOURNEYS = 'ACCEPT_JOURNEYS',
  PLAN_JOURNEYS = 'PLAN_JOURNEYS',
  PERFORM_JOURNEYS = 'PERFORM_JOURNEYS',
  READ_ASSIGNED_JOURNEYS = 'READ_ASSIGNED_JOURNEYS',
  READ_OWN_INVOICES = 'READ_OWN_INVOICES',
  READ_COMPANY_DATA = 'READ_COMPANY_DATA',
  WRITE_COMPANY_DATA = 'WRITE_COMPANY_DATA',
  WRITE_JOURNEY_OFFERINGS = 'WRITE_JOURNEY_OFFERINGS',
  IMPERSONATE_USERS = 'IMPERSONATE_USERS',
  CANCEL_JOURNEYS_OUTSIDE_WINDOW = 'CANCEL_JOURNEYS_OUTSIDE_WINDOW',
  CANCEL_JOURNEYS = 'CANCEL_JOURNEYS',
  CHANGE_JOURNEYS_WITHOUT_PAYMENT = 'CHANGE_JOURNEYS_WITHOUT_PAYMENT',
  EDIT_JOURNEYS_MINOR_DETAILS = 'EDIT_JOURNEYS_MINOR_DETAILS',
  EDIT_JOURNEYS_MAJOR_DETAILS = 'EDIT_JOURNEYS_MAJOR_DETAILS',
  READ_COMMENTS = 'READ_COMMENTS',
  WRITE_COMMENTS = 'WRITE_COMMENTS',
  CHANGE_JOURNEY_PICKUP_WITHIN_MINIMUM_NOTICE = 'CHANGE_JOURNEY_PICKUP_WITHIN_MINIMUM_NOTICE',
}

export enum PermissionName {
  READ_NON_SENSITIVE = 'READ_NON_SENSITIVE',
  READ_USERS = 'READ_USERS',
  WRITE_USERS = 'WRITE_USERS',
  READ_ORGS = 'READ_ORGS',
  WRITE_ORGS = 'WRITE_ORGS',
  READ_HUBS = 'READ_HUBS',
  WRITE_HUBS = 'WRITE_HUBS',
  READ_QUOTES = 'READ_QUOTES',
  WRITE_QUOTES = 'WRITE_QUOTES',
  READ_BOOKINGS = 'READ_BOOKINGS',
  WRITE_BOOKINGS = 'WRITE_BOOKINGS',
  READ_TRANSCOS = 'READ_TRANSCOS',
  WRITE_TRANSCOS = 'WRITE_TRANSCOS',
  READ_PARTNERS = 'READ_PARTNERS',
  WRITE_PARTNERS = 'WRITE_PARTNERS',
  READ_INVOICES = 'READ_INVOICES',
  WRITE_INVOICES = 'WRITE_INVOICES',
  SEND_EMAIL = 'SEND_EMAIL',
  VIEW_SENT_EMAIL = 'VIEW_SENT_EMAIL',
  TRIGGER_DATA_SYNC = 'TRIGGER_DATA_SYNC',
  MANAGE_DATA_SYNC = 'MANAGE_DATA_SYNC',
  GEO_SEARCH = 'GEO_SEARCH',
  CREATE_BOOKINGS = 'CREATE_OWN_BOOKINGS',
  VIEW_OWN_BOOKINGS = 'VIEW_OWN_BOOKINGS',
  ACCEPT_JOURNEYS = 'ACCEPT_JOURNEYS',
  PLAN_JOURNEYS = 'PLAN_JOURNEYS',
  PERFORM_JOURNEYS = 'PERFORM_JOURNEYS',
  READ_ASSIGNED_JOURNEYS = 'READ_ASSIGNED_JOURNEYS',
  READ_OWN_INVOICES = 'READ_OWN_INVOICES',
  READ_COMPANY_DATA = 'READ_COMPANY_DATA',
  WRITE_COMPANY_DATA = 'WRITE_COMPANY_DATA',
  WRITE_JOURNEY_OFFERINGS = 'WRITE_JOURNEY_OFFERINGS',
  IMPERSONATE_USERS = 'IMPERSONATE_USERS',
  CANCEL_JOURNEYS_OUTSIDE_WINDOW = 'CANCEL_JOURNEYS_OUTSIDE_WINDOW',
  CANCEL_JOURNEYS = 'CANCEL_JOURNEYS',
  CHANGE_JOURNEYS_WITHOUT_PAYMENT = 'CHANGE_JOURNEYS_WITHOUT_PAYMENT',
  EDIT_JOURNEYS_MINOR_DETAILS = 'EDIT_JOURNEYS_MINOR_DETAILS',
  EDIT_JOURNEYS_MAJOR_DETAILS = 'EDIT_JOURNEYS_MAJOR_DETAILS',
  READ_COMMENTS = 'READ_COMMENTS',
  WRITE_COMMENTS = 'WRITE_COMMENTS',
  CHANGE_JOURNEY_PICKUP_WITHIN_MINIMUM_NOTICE = 'CHANGE_JOURNEY_PICKUP_WITHIN_MINIMUM_NOTICE',
}

export enum RoleType {
  Org = 'ORGANIZATIONAL',
  Global = 'GLOBAL',
}

export enum PermissionType {
  Org = 'ORGANIZATIONAL',
  Global = 'GLOBAL',
}

export const ROLES_GROUPS = {
  [RoleType.Global]: [
    RoleName.READ_NON_SENSITIVE,
    RoleName.READ_USERS,
    RoleName.WRITE_USERS,
    RoleName.READ_ORGS,
    RoleName.WRITE_ORGS,
    RoleName.READ_HUBS,
    RoleName.WRITE_HUBS,
    RoleName.READ_QUOTES,
    RoleName.WRITE_QUOTES,
    RoleName.READ_BOOKINGS,
    RoleName.WRITE_BOOKINGS,
    RoleName.READ_TRANSCOS,
    RoleName.WRITE_TRANSCOS,
    RoleName.READ_PARTNERS,
    RoleName.WRITE_PARTNERS,
    RoleName.READ_INVOICES,
    RoleName.WRITE_INVOICES,
    RoleName.SEND_EMAIL,
    RoleName.VIEW_SENT_EMAIL,
    RoleName.TRIGGER_DATA_SYNC,
    RoleName.MANAGE_DATA_SYNC,
    RoleName.GEO_SEARCH,
    RoleName.WRITE_JOURNEY_OFFERINGS,
    RoleName.IMPERSONATE_USERS,
    RoleName.CANCEL_JOURNEYS_OUTSIDE_WINDOW,
    RoleName.CHANGE_JOURNEYS_WITHOUT_PAYMENT,
    RoleName.READ_COMMENTS,
    RoleName.WRITE_COMMENTS,
    RoleName.CHANGE_JOURNEY_PICKUP_WITHIN_MINIMUM_NOTICE,
  ],
  [RoleType.Org]: [
    RoleName.CREATE_BOOKINGS,
    RoleName.VIEW_OWN_BOOKINGS,
    RoleName.ACCEPT_JOURNEYS,
    RoleName.PLAN_JOURNEYS,
    RoleName.PERFORM_JOURNEYS,
    RoleName.READ_ASSIGNED_JOURNEYS,
    RoleName.READ_OWN_INVOICES,
    RoleName.READ_COMPANY_DATA,
    RoleName.WRITE_COMPANY_DATA,
    RoleName.CANCEL_JOURNEYS,
    RoleName.EDIT_JOURNEYS_MINOR_DETAILS,
    RoleName.EDIT_JOURNEYS_MAJOR_DETAILS,
  ],
};

export const PERMISSIONS_GROUPS = {
  [PermissionType.Global]: [
    PermissionName.READ_NON_SENSITIVE,
    PermissionName.READ_USERS,
    PermissionName.WRITE_USERS,
    PermissionName.READ_ORGS,
    PermissionName.WRITE_ORGS,
    PermissionName.READ_HUBS,
    PermissionName.WRITE_HUBS,
    PermissionName.READ_QUOTES,
    PermissionName.WRITE_QUOTES,
    PermissionName.READ_BOOKINGS,
    PermissionName.WRITE_BOOKINGS,
    PermissionName.READ_TRANSCOS,
    PermissionName.WRITE_TRANSCOS,
    PermissionName.READ_PARTNERS,
    PermissionName.WRITE_PARTNERS,
    PermissionName.READ_INVOICES,
    PermissionName.WRITE_INVOICES,
    PermissionName.SEND_EMAIL,
    PermissionName.VIEW_SENT_EMAIL,
    PermissionName.TRIGGER_DATA_SYNC,
    PermissionName.MANAGE_DATA_SYNC,
    PermissionName.GEO_SEARCH,
    PermissionName.WRITE_JOURNEY_OFFERINGS,
    PermissionName.IMPERSONATE_USERS,
    PermissionName.CANCEL_JOURNEYS_OUTSIDE_WINDOW,
    PermissionName.CHANGE_JOURNEYS_WITHOUT_PAYMENT,
    PermissionName.READ_COMMENTS,
    PermissionName.WRITE_COMMENTS,
    PermissionName.CHANGE_JOURNEY_PICKUP_WITHIN_MINIMUM_NOTICE,
  ],
  [PermissionType.Org]: [
    PermissionName.CREATE_BOOKINGS,
    PermissionName.VIEW_OWN_BOOKINGS,
    PermissionName.ACCEPT_JOURNEYS,
    PermissionName.PLAN_JOURNEYS,
    PermissionName.PERFORM_JOURNEYS,
    PermissionName.READ_ASSIGNED_JOURNEYS,
    PermissionName.READ_OWN_INVOICES,
    PermissionName.READ_COMPANY_DATA,
    PermissionName.WRITE_COMPANY_DATA,
    PermissionName.CANCEL_JOURNEYS,
    PermissionName.EDIT_JOURNEYS_MINOR_DETAILS,
    PermissionName.EDIT_JOURNEYS_MAJOR_DETAILS,
  ],
};

export const RoleDisplayNames = {
  [RoleName.READ_NON_SENSITIVE]: 'Read non-sensitive',
  [RoleName.READ_USERS]: 'Read users',
  [RoleName.WRITE_USERS]: 'Write users',
  [RoleName.READ_ORGS]: 'Read orgs',
  [RoleName.WRITE_ORGS]: 'Write orgs',
  [RoleName.READ_HUBS]: 'Read hubs',
  [RoleName.WRITE_HUBS]: 'Write hubs',
  [RoleName.READ_QUOTES]: 'Read quotes',
  [RoleName.WRITE_QUOTES]: 'Write quotes',
  [RoleName.READ_BOOKINGS]: 'Read bookings',
  [RoleName.WRITE_BOOKINGS]: 'Write bookings',
  [RoleName.READ_TRANSCOS]: 'Read transcos',
  [RoleName.WRITE_TRANSCOS]: 'Write transcos',
  [RoleName.READ_PARTNERS]: 'Read partners',
  [RoleName.WRITE_PARTNERS]: 'Write partners',
  [RoleName.READ_INVOICES]: 'Read invoices',
  [RoleName.WRITE_INVOICES]: 'Write invoices',
  [RoleName.SEND_EMAIL]: 'Send email',
  [RoleName.VIEW_SENT_EMAIL]: 'View sent email',
  [RoleName.TRIGGER_DATA_SYNC]: 'Trigger data sync',
  [RoleName.MANAGE_DATA_SYNC]: 'Manage data sync',
  [RoleName.GEO_SEARCH]: 'Geo search',
  [RoleName.CREATE_BOOKINGS]: 'Create own bookings',
  [RoleName.VIEW_OWN_BOOKINGS]: 'View own bookings',
  [RoleName.ACCEPT_JOURNEYS]: 'Accept journeys',
  [RoleName.PLAN_JOURNEYS]: 'Plan journeys',
  [RoleName.PERFORM_JOURNEYS]: 'Perform journeys',
  [RoleName.READ_ASSIGNED_JOURNEYS]: 'Read assigned journeys',
  [RoleName.READ_OWN_INVOICES]: 'Read own invoices',
  [RoleName.READ_COMPANY_DATA]: 'Read company data',
  [RoleName.WRITE_COMPANY_DATA]: 'Write company data',
  [RoleName.WRITE_JOURNEY_OFFERINGS]: 'Write journey offerings',
  [RoleName.IMPERSONATE_USERS]: 'Impersonate users',
  [RoleName.CANCEL_JOURNEYS]: 'Cancel Journeys',
  [RoleName.EDIT_JOURNEYS_MINOR_DETAILS]: 'Edit minor details',
  [RoleName.EDIT_JOURNEYS_MAJOR_DETAILS]: 'Edit major details',
  [RoleName.READ_COMMENTS]: 'Read comments',
  [RoleName.WRITE_COMMENTS]: 'Write comments',
  [RoleName.CHANGE_JOURNEY_PICKUP_WITHIN_MINIMUM_NOTICE]: 'Change journey pickup within minimum notice',
};

export const PermissionDisplayNames = {
  [PermissionName.READ_NON_SENSITIVE]: 'Read non-sensitive',
  [PermissionName.READ_USERS]: 'Read users',
  [PermissionName.WRITE_USERS]: 'Write users',
  [PermissionName.READ_ORGS]: 'Read orgs',
  [PermissionName.WRITE_ORGS]: 'Write orgs',
  [PermissionName.READ_HUBS]: 'Read hubs',
  [PermissionName.WRITE_HUBS]: 'Write hubs',
  [PermissionName.READ_QUOTES]: 'Read quotes',
  [PermissionName.WRITE_QUOTES]: 'Write quotes',
  [PermissionName.READ_BOOKINGS]: 'Read bookings',
  [PermissionName.WRITE_BOOKINGS]: 'Write bookings',
  [PermissionName.READ_TRANSCOS]: 'Read transcos',
  [PermissionName.WRITE_TRANSCOS]: 'Write transcos',
  [PermissionName.READ_PARTNERS]: 'Read partners',
  [PermissionName.WRITE_PARTNERS]: 'Write partners',
  [PermissionName.READ_INVOICES]: 'Read invoices',
  [PermissionName.WRITE_INVOICES]: 'Write invoices',
  [PermissionName.SEND_EMAIL]: 'Send email',
  [PermissionName.VIEW_SENT_EMAIL]: 'View sent email',
  [PermissionName.TRIGGER_DATA_SYNC]: 'Trigger data sync',
  [PermissionName.MANAGE_DATA_SYNC]: 'Manage data sync',
  [PermissionName.GEO_SEARCH]: 'Geo search',
  [PermissionName.CREATE_BOOKINGS]: 'Create own bookings',
  [PermissionName.VIEW_OWN_BOOKINGS]: 'View own bookings',
  [PermissionName.ACCEPT_JOURNEYS]: 'Accept journeys',
  [PermissionName.PLAN_JOURNEYS]: 'Plan journeys',
  [PermissionName.PERFORM_JOURNEYS]: 'Perform journeys',
  [PermissionName.READ_ASSIGNED_JOURNEYS]: 'Read assigned journeys',
  [PermissionName.READ_OWN_INVOICES]: 'Read own invoices',
  [PermissionName.READ_COMPANY_DATA]: 'Read company data',
  [PermissionName.WRITE_COMPANY_DATA]: 'Write company data',
  [PermissionName.WRITE_JOURNEY_OFFERINGS]: 'Write journey offerings',
  [PermissionName.IMPERSONATE_USERS]: 'Impersonate users',
  [PermissionName.CANCEL_JOURNEYS]: 'Cancel Journeys',
  [PermissionName.EDIT_JOURNEYS_MINOR_DETAILS]: 'Edit minor details',
  [PermissionName.EDIT_JOURNEYS_MAJOR_DETAILS]: 'Edit major details',
  [PermissionName.READ_COMMENTS]: 'Read comments',
  [PermissionName.WRITE_COMMENTS]: 'Write comments',
  [PermissionName.CHANGE_JOURNEY_PICKUP_WITHIN_MINIMUM_NOTICE]: 'Change journey pickup within minimum notice',
};

export interface IUserCredentials {
  email: string;
  password: string;
}

export interface IUser {
  id: number;
  name: string;
  email: string;
  created: string;
  lastLogin: string;
  invalidLoginAttempts: number;
  accountState: string;
  emailVerified: string;
  type: string;
}

export interface IDestinationManager {
  id: number;
  name: string;
  email: string;
}

export const  AccountStateDisplayName =  {
  [AccountState.Active]: 'Active',
  [AccountState.Locked]: 'Locked',
  [AccountState.Deactivated]: 'Deactivated',
}

export interface IUserRole {
  id: number | string;
  role: RoleName | string;
  organization: IOrganization | null;
  partner?: IPartner;
}

export enum UserType {
  InternalUser = 'INTERNAL_USER',
  ExternalUser = 'EXTERNAL_USER',
  InternalSystem = 'INTERNAL_SYSTEM',
  ExternalSystem = 'EXTERNAL_SYSTEM',
}

export const UserTypeDisplayNames = {
  [UserType.InternalUser]: 'Internal user',
  [UserType.ExternalUser]: 'External user',
  [UserType.InternalSystem]: 'Internal system',
  [UserType.ExternalSystem]: 'External system',
}

export interface IUsersByPermissionRequestParams {
  permission: string;
}

export interface IUserAvailableRole {
  id: number;
  name: string;
  description: string;
  permissions: string[];
  userType: string;
  permissionType: string;
}
